import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environment/environment';

export interface RotorType {
  name?: string;
}

interface GridResponse {
  data: RotorType[];
}

@Injectable()
export class RotorApi {
  private readonly http = inject(HttpClient);

  public getRotorsByMachineId$(id: string): Observable<RotorType[]> {
    return this.http
      .get<GridResponse>(`${environment.rmBaseUrl}/TypeData?MachineIds=${id}`)
      .pipe(map((response) => response.data));
  }
}
